// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"376":"16e16baf","720":"37f9cb12"}[chunkId] + ".chunk.js";
};